/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `guarantee` - Guarantee
 * * `percentage` - Percentage
 * * `guarantee_plus` - Guarantee + Percentage
 * * `door_deal` - Door Deal
 * * `comp` - Comp/Free
 * * `other` - Other
 * @export
 */
export const DealTypeEnum = {
    Guarantee: 'guarantee',
    Percentage: 'percentage',
    GuaranteePlus: 'guarantee_plus',
    DoorDeal: 'door_deal',
    Comp: 'comp',
    Other: 'other'
} as const;
export type DealTypeEnum = typeof DealTypeEnum[keyof typeof DealTypeEnum];


export function instanceOfDealTypeEnum(value: any): boolean {
    for (const key in DealTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(DealTypeEnum, key)) {
            if (DealTypeEnum[key as keyof typeof DealTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DealTypeEnumFromJSON(json: any): DealTypeEnum {
    return DealTypeEnumFromJSONTyped(json, false);
}

export function DealTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DealTypeEnum {
    return json as DealTypeEnum;
}

export function DealTypeEnumToJSON(value?: DealTypeEnum | null): any {
    return value as any;
}

export function DealTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DealTypeEnum {
    return value as DealTypeEnum;
}

